import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SatisfactionConfigService } from 'src/app/services/satisfaction-services/satisfaction-config-service/satisfaction-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-satisfaction-config-type-card',
  templateUrl: './satisfaction-config-type-card.component.html',
  styleUrls: ['./satisfaction-config-type-card.component.scss']
})
export class SatisfactionConfigTypeCardComponent implements OnInit, OnChanges {

  @Input() ratingType;
  ratingTypes = [
    {
      id: 'FACES',
      value: '☹️😕😐😉🙂'
    }, {
      id: 'STARS',
      value: '⭐⭐⭐⭐⭐'
    }
  ];
  updateSatisfactionsConfigTypeSubscription: Subscription;

  basicDataForm = new FormGroup({
    ratingType: new FormControl(null, Validators.required)
  });

  constructor(private satisfactionConfigService: SatisfactionConfigService,
              private snackbarService: SnackBarService) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.ratingType) {
      this.resetForm();
    }
  }

  public submitForm(value) {
    this.updateSatisfactionsConfigTypeSubscription = this.satisfactionConfigService.updateSatisfactionConfigType(value.id).pipe(
      tap(o => this.satisfactionConfigService.refreshSatisfactionsConfig()),
      catchError(error => {
        this.snackbarService.open(error['data']['error'], 'error');
        this.satisfactionConfigService.refreshSatisfactionsConfig();
        return EMPTY; })
    ).subscribe();
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      ratingType: this.getSelectedRatingType(this.ratingType)
    });
  }

  private getSelectedRatingType(ratingType) {
    return this.ratingTypes.find(o => o.id === ratingType);
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.id === op2.id;
    }
  }
}
